import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PhpMailServiceService {
  private apiUrl = './assets/mail/send-mail-contact-us.php';
  constructor(private httpClient: HttpClient) { }


  public sendMailContactUs(data: any): Observable<any> {
    console.log(data);
    console.log('pankaj bhaiya');
    let formdata = new FormData();
    formdata.append('data', JSON.stringify(data)),
      console.log('pankaj bhaiya-2');
      console.log('formdata ,' + formdata);
    // return this.httpClient.post(this.apiUrl, data, {});
    return this.httpClient.post('./assets/mail/send-mail-contact-us.php', formdata);


  }
}
